import React from 'react';
import { FaCheckCircle, FaStore, FaUtensils, FaClock, FaTimesCircle } from 'react-icons/fa';

const ResumoPedido = ({ pedido, onCancelar }) => {
  if (!pedido) return null;

  return (
    <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white mb-4">
      <div className="card-header border-0 text-white p-3.5" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <FaCheckCircle className="fs-4 me-2 text-white" />
            <h5 className="fw-bold m-0 text-white">Pedido Realizado com Sucesso!</h5>
          </div>
          <span className="badge bg-white text-danger fw-bold px-3 py-1.5 rounded-3">
            Status: Solicitado
          </span>
        </div>
      </div>

      <div className="card-body p-3.5 bg-white">
        <div className="row g-3">
          <div className="col-12 col-md-6">
            <div className="p-3 bg-light rounded-3 border h-100">
              <small className="text-muted d-block extra-small fw-bold text-uppercase mb-1">Restaurante</small>
              <span className="fw-bold text-dark fs-6 d-flex align-items-center gap-1.5">
                <FaUtensils className="text-danger" /> {pedido.restaurante?.nomeamigavel || 'Não informado'}
              </span>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="p-3 bg-light rounded-3 border h-100">
              <small className="text-muted d-block extra-small fw-bold text-uppercase mb-1">Loja</small>
              <span className="fw-bold text-dark fs-6 d-flex align-items-center gap-1.5">
                <FaStore className="text-danger" /> Loja {pedido.restaurante?.loja || '--'}
              </span>
            </div>
          </div>

          <div className="col-6 col-md-3">
            <div className="p-3 bg-light rounded-3 border h-100">
              <small className="text-muted d-block extra-small fw-bold text-uppercase mb-1">Turno</small>
              <span className="fw-bold text-dark fs-6 d-flex align-items-center gap-1.5">
                <FaClock className="text-danger" /> {(pedido.turno === null || pedido.turno === 0 || pedido.turno === 1) ? '1º Turno' : '2º Turno'}
              </span>
            </div>
          </div>

          <div className="col-12">
            <div className="p-3 bg-light rounded-3 border">
              <small className="text-muted d-block extra-small fw-bold text-uppercase mb-1">Cardápio Selecionado</small>
              <span className="fw-bold text-dark">{pedido.opcao || 'Restaurante Local'}</span>

              {pedido.observacao && (
                <div className="mt-2 pt-2 border-top">
                  <small className="text-muted d-block extra-small fw-bold">Observação:</small>
                  <span className="small text-secondary">{pedido.observacao}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {(pedido.restaurante?.status === 0 || pedido.status === 0) && (
          <div className="mt-4 pt-3 border-top text-end">
            <button 
              className="btn btn-sm btn-outline-danger fw-bold px-4 py-2 rounded-3 d-inline-flex align-items-center gap-1.5" 
              onClick={onCancelar}
            >
              <FaTimesCircle /> Cancelar Pedido
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResumoPedido;